import React, { createContext, useContext, useEffect, useState } from "react";

const dict = {
  id: {
    nav: { home: "Beranda", about: "Tentang", menu: "Menu", shop: "Toko", events: "Acara", contact: "Kontak", admin: "Admin", cart: "Keranjang" },
    home: {
      eyebrow: "Kedai kopi spesialti",
      title: "Setiap cangkir\nadalah percakapan.",
      subtitle: "SUNKOP menyeduh biji single-origin dari petani Nusantara pilihan — di ruang yang dirancang untuk berlambat sejenak.",
      cta_menu: "Lihat Menu", cta_shop: "Belanja Biji",
      section1_eyebrow: "Filosofi",
      section1_title: "Slow coffee, slow living.",
      section1_body: "Kami tidak sekadar menjual kopi. Kami membangun hubungan jangka panjang dengan petani, membeli dengan harga adil, dan memanggang dalam batch kecil agar setiap karakter biji tetap hidup.",
      hours_title: "Jam Operasional", location_title: "Lokasi",
      hours: "Senin - Jumat: 07:00 - 22:00\nSabtu - Minggu: 08:00 - 23:00",
      addr: "Jl. Cendana No. 24\nJakarta Selatan, DKI Jakarta",
    },
    about: {
      eyebrow: "Cerita kami",
      title: "Dari sawah, ke sangrai, ke cangkirmu.",
      story: "SUNKOP lahir dari obsesi sederhana: apa jadinya kalau kopi diperlakukan seperti wine? Kami menelusuri desa-desa penghasil kopi terbaik Indonesia — Gayo, Kintamani, Toraja, Java Preanger — bermalam di rumah petani, memahami tanah, iklim, dan tangan yang memetiknya.",
      sourcing_title: "Sumber",
      sourcing_body: "Direct trade dengan lebih dari 30 keluarga petani. Traceable dari plot ke roasting drum.",
      roast_title: "Sangrai",
      roast_body: "Small batch harian di roaster Probat 12kg. Setiap origin punya profile sangrai yang dikembangkan selama berbulan-bulan.",
      brew_title: "Seduh",
      brew_body: "Barista kami dilatih untuk mengeluarkan karakter terbaik dari setiap biji. Espresso, manual brew, cold brew — semua dikalibrasi harian.",
    },
    menu: { title: "Menu", eyebrow: "Yang bisa kamu pesan", all: "Semua", coffee: "Kopi", "non-coffee": "Non-Kopi", food: "Makanan", seasonal: "Musiman" },
    shop: {
      title: "Biji Kopi",
      eyebrow: "Bawa pulang",
      subtitle: "Roasted weekly. Vacuum sealed. Delivered fresh.",
      add_to_cart: "Tambahkan", view: "Lihat", price: "Harga",
      origin: "Asal", roast: "Sangrai", notes: "Cita Rasa", weight: "Berat",
    },
    cart: {
      title: "Keranjang", empty: "Keranjang masih kosong.", browse: "Jelajahi toko",
      subtotal: "Subtotal", shipping: "Ongkir", total: "Total", checkout: "Lanjut ke Checkout",
      remove: "Hapus", qty: "Jumlah",
    },
    checkout: {
      title: "Checkout", customer: "Data Pelanggan", shipping: "Alamat Pengiriman",
      name: "Nama Lengkap", email: "Email", phone: "Nomor HP", address: "Alamat", city: "Kota", postal: "Kode Pos",
      notes: "Catatan (opsional)", pay: "Bayar Sekarang", pay_note: "Pembayaran akan disimulasikan untuk MVP.",
      order_placed: "Pesanan Dibuat", order_number: "Nomor Pesanan", pay_now: "Bayar Sekarang (Mock)",
      thank_you: "Terima kasih! Pembayaran diterima.", status: "Status Pesanan",
    },
    events: {
      title: "Sewa Ruang & Acara", eyebrow: "Rayakan di SUNKOP",
      intro: "Ruang kami menampung hingga 60 orang. Ideal untuk peluncuran produk, lokakarya, gathering komunitas, atau pesta pribadi.",
      packages: "Paket", basic: "Basic", standard: "Standard", premium: "Premium",
      reserve: "Ajukan Reservasi", availability: "Ketersediaan",
      form_title: "Formulir Reservasi", event_type: "Jenis Acara", date: "Tanggal", start: "Mulai", end: "Selesai",
      guests: "Jumlah Tamu", package: "Pilih Paket", requests: "Permintaan Khusus", submit: "Ajukan",
      thanks: "Reservasi terkirim! Tim kami akan menghubungi Anda dalam 24 jam.",
    },
    contact: {
      title: "Hubungi Kami", eyebrow: "Sapa dulu",
      phone: "Telepon", email: "Email", wa: "WhatsApp", social: "Sosial Media",
    },
    admin: {
      login: "Masuk sebagai Admin", login_google: "Masuk dengan Google", dashboard: "Dashboard",
      revenue_today: "Pendapatan Hari Ini", revenue_week: "Minggu Ini", revenue_month: "Bulan Ini",
      new_inquiries: "Inquiry Baru", pending_orders: "Order Pending", customers: "Pelanggan",
      menu_mgmt: "Kelola Menu", product_mgmt: "Kelola Produk", orders: "Pesanan",
      events_crm: "Acara / CRM", export: "Ekspor CSV", logout: "Keluar",
    },
  },
  en: {
    nav: { home: "Home", about: "About", menu: "Menu", shop: "Shop", events: "Events", contact: "Contact", admin: "Admin", cart: "Cart" },
    home: {
      eyebrow: "Specialty coffee house",
      title: "Every cup\nis a conversation.",
      subtitle: "SUNKOP brews single-origin beans from carefully selected Indonesian farmers — in a space designed for slowing down.",
      cta_menu: "See Menu", cta_shop: "Shop Beans",
      section1_eyebrow: "Philosophy",
      section1_title: "Slow coffee, slow living.",
      section1_body: "We don't just sell coffee. We build long-term relationships with farmers, buy at fair prices, and roast in small batches so each bean's character stays alive.",
      hours_title: "Opening Hours", location_title: "Location",
      hours: "Mon - Fri: 7:00 AM - 10:00 PM\nSat - Sun: 8:00 AM - 11:00 PM",
      addr: "Jl. Cendana No. 24\nSouth Jakarta, DKI Jakarta",
    },
    about: {
      eyebrow: "Our story",
      title: "From farm, to roast, to your cup.",
      story: "SUNKOP was born from a simple obsession: what if coffee was treated like wine? We travelled through Indonesia's best coffee villages — Gayo, Kintamani, Toraja, Java Preanger — sleeping in farmers' homes, learning the soil, climate, and the hands that pick each cherry.",
      sourcing_title: "Sourcing",
      sourcing_body: "Direct trade with 30+ farming families. Traceable from plot to roasting drum.",
      roast_title: "Roasting",
      roast_body: "Small batches daily on a Probat 12kg roaster. Each origin has a roast profile developed over months.",
      brew_title: "Brewing",
      brew_body: "Our baristas are trained to draw out the best of each bean. Espresso, pour over, cold brew — all calibrated daily.",
    },
    menu: { title: "Menu", eyebrow: "What you can order", all: "All", coffee: "Coffee", "non-coffee": "Non-Coffee", food: "Food", seasonal: "Seasonal" },
    shop: {
      title: "Coffee Beans",
      eyebrow: "Take home",
      subtitle: "Roasted weekly. Vacuum sealed. Delivered fresh.",
      add_to_cart: "Add to Cart", view: "View", price: "Price",
      origin: "Origin", roast: "Roast", notes: "Tasting Notes", weight: "Weight",
    },
    cart: {
      title: "Cart", empty: "Your cart is empty.", browse: "Browse shop",
      subtotal: "Subtotal", shipping: "Shipping", total: "Total", checkout: "Continue to Checkout",
      remove: "Remove", qty: "Qty",
    },
    checkout: {
      title: "Checkout", customer: "Customer Info", shipping: "Shipping Address",
      name: "Full Name", email: "Email", phone: "Phone", address: "Address", city: "City", postal: "Postal Code",
      notes: "Notes (optional)", pay: "Pay Now", pay_note: "Payment will be simulated for MVP.",
      order_placed: "Order Placed", order_number: "Order Number", pay_now: "Pay Now (Mock)",
      thank_you: "Thanks! Payment received.", status: "Order Status",
    },
    events: {
      title: "Space & Event Booking", eyebrow: "Celebrate at SUNKOP",
      intro: "Our space seats up to 60. Perfect for product launches, workshops, community meet-ups, or private parties.",
      packages: "Packages", basic: "Basic", standard: "Standard", premium: "Premium",
      reserve: "Request Reservation", availability: "Availability",
      form_title: "Reservation Form", event_type: "Event Type", date: "Date", start: "Start", end: "End",
      guests: "Guests", package: "Select Package", requests: "Special Requests", submit: "Submit",
      thanks: "Reservation submitted! Our team will contact you within 24 hours.",
    },
    contact: {
      title: "Get in touch", eyebrow: "Say hi",
      phone: "Phone", email: "Email", wa: "WhatsApp", social: "Social",
    },
    admin: {
      login: "Sign in as Admin", login_google: "Sign in with Google", dashboard: "Dashboard",
      revenue_today: "Today's Revenue", revenue_week: "This Week", revenue_month: "This Month",
      new_inquiries: "New Inquiries", pending_orders: "Pending Orders", customers: "Customers",
      menu_mgmt: "Menu Management", product_mgmt: "Products", orders: "Orders",
      events_crm: "Events / CRM", export: "Export CSV", logout: "Logout",
    },
  },
};

const I18nCtx = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("sk_lang") || "id");
  useEffect(() => { localStorage.setItem("sk_lang", lang); document.documentElement.lang = lang; }, [lang]);
  const t = (path) => {
    const parts = path.split(".");
    let cur = dict[lang];
    for (const p of parts) { if (cur == null) return path; cur = cur[p]; }
    return cur == null ? path : cur;
  };
  return <I18nCtx.Provider value={{ lang, setLang, t }}>{children}</I18nCtx.Provider>;
}

export const useI18n = () => useContext(I18nCtx);
